import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";

export const NavDropdown = ({ label, to, items, testid }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const loc = useLocation();

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname, loc.hash]);

  return (
    <div
      ref={ref}
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onKeyDown={(e) => { if (e.key === "Escape") setOpen(false); }}
    >
      <div className="flex items-center">
        <NavLink
          to={to}
          data-testid={testid}
          className={({ isActive }) =>
            `pl-3 pr-1 py-2 text-sm font-medium rounded-lg transition-colors ${isActive ? "text-white bg-white/5" : "text-slate-300 hover:text-white hover:bg-white/5"}`
          }
        >{label}</NavLink>
        <button
          type="button"
          aria-haspopup="true"
          aria-expanded={open}
          aria-label={`${label} menu`}
          data-testid={`${testid}-toggle`}
          onClick={(e) => {
            if (e.detail === 0) setOpen((o) => !o);
            else setOpen(true);
          }}
          className="p-1.5 text-slate-400 hover:text-white rounded-md transition-colors"
        >
          <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
      </div>
      {open && (
        <div className="absolute left-0 top-full pt-2 z-50" data-testid={`${testid}-dropdown`}>
          <div className="w-64 rounded-xl border border-white/10 bg-[#0A1226]/95 backdrop-blur-xl shadow-2xl p-2">
            {items.map((it) => (
              <Link
                key={it.to}
                to={it.to}
                data-testid={`${testid}-item-${it.to.split("#")[1] || "page"}`}
                className="block px-3 py-2 rounded-lg text-sm text-slate-300 hover:text-white hover:bg-white/5 transition-colors"
              >{it.label}</Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export const MobileNavGroup = ({ label, to, items, testid, onNavigate }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <div className="flex items-center">
        <NavLink
          to={to}
          data-testid={`mobile-${testid}`}
          onClick={onNavigate}
          className={({ isActive }) => `flex-1 px-3 py-2.5 rounded-lg ${isActive ? "bg-white/10 text-white" : "text-slate-300"}`}
        >{label}</NavLink>
        <button
          type="button"
          aria-expanded={open}
          aria-label={`${label} menu`}
          data-testid={`mobile-${testid}-toggle`}
          onClick={() => setOpen((o) => !o)}
          className="p-2.5 text-slate-400 hover:text-white"
        >
          <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
      </div>
      {open && (
        <div className="pl-5 pb-1 space-y-0.5">
          {items.map((it) => (
            <Link
              key={it.to}
              to={it.to}
              data-testid={`mobile-${testid}-item-${it.to.split("#")[1] || "page"}`}
              onClick={onNavigate}
              className="block px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-white"
            >{it.label}</Link>
          ))}
        </div>
      )}
    </div>
  );
};
